import CloudDoneIcon from "@mui/icons-material/CloudDone";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LoopIcon from "@mui/icons-material/Loop";
import Box from "@mui/material/Box";
import type { SxProps } from "@mui/material/styles";
import useTheme from "@mui/material/styles/useTheme";

export type DataSaveStateStatus = "saved" | "dirty" | "error";

const spinAnimation = {
  animation: "spin 1.5s linear infinite",
  "@keyframes spin": {
    "0%": {
      transform: "rotate(360deg)"
    },
    "100%": {
      transform: "rotate(0deg)"
    }
  }
};
interface DataSaveStateProps {
  state: DataSaveStateStatus;
  sx?: SxProps;
}

export default function DataSaveState({ state, sx }: DataSaveStateProps) {
  const { palette } = useTheme();

  const wrapperStyles = {
    display: "flex",
    alignItems: "center",
    color: "#fff",
    ...sx
  };

  const iconStyles = { color: "inherit", mr: 1 };
  const testId = "data-save-state";

  if (state === "dirty") {
    return (
      <Box
        data-testid={testId}
        sx={{ ...wrapperStyles, color: palette.secondary.light }}
      >
        <LoopIcon
          sx={{
            ...iconStyles,
            ...spinAnimation
          }}
          fontSize="small"
        />
      </Box>
    );
  }

  if (state === "error")
    return (
      <Box
        data-testid={testId}
        sx={{ ...wrapperStyles, color: palette.error.light }}
      >
        <ErrorOutlineIcon sx={iconStyles} fontSize="small" />
      </Box>
    );

  if (state === "saved")
    return (
      <Box
        data-testid={testId}
        sx={{ ...wrapperStyles, color: palette.success.light }}
      >
        <CloudDoneIcon sx={iconStyles} fontSize="small" />
      </Box>
    );

  return null;
}
